import { useThree, useFrame } from '@react-three/fiber';
import { useEffect, useState } from 'react';
import * as THREE from 'three';

const Rig = ({ explode }) => {
  const { camera } = useThree();
  const [mx, setMx] = useState(0);
  const [my, setMy] = useState(0);
  useEffect(() => {
    let element = document.querySelector('body');
    element.addEventListener('mousemove', (e) => {
      setMx(e.clientX / window.innerWidth);
      setMy(-e.clientY / window.innerHeight);
    });
  }, []);
  const vec = new THREE.Vector3();
  return useFrame(() => {
    camera.position.lerp(vec.set(mx * 1.2, my * 1, explode ? 4.5 : 2.5), 0.02);
  });
};

export default Rig;
